import React, { Suspense } from 'react';
import { DialogProps } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import { AspectRatio } from '@jucy-ui/components';
import { CmsEmbedObject } from '@/services/cms/models/CmsEmbedObject';

const ReactPlayer = React.lazy(() => import('react-player'));

export const VideoTeaserBlockModal = ({ video, ...props }: DialogProps & { video?: CmsEmbedObject }) => {
    const sourceUrl = video?.sourceUrl ? new URL(video?.sourceUrl) : undefined;
    const videoId = sourceUrl?.searchParams.get('v');
    if (!videoId) {
        return null;
    }
    return (
        <Dialog {...props}>
            <AspectRatio ratio={16 / 9}>
                <Box sx={(theme) => ({ position: 'absolute', width: '100%', height: '100%', backgroundColor: theme.palette.common.black })}>
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            margin: 'auto',
                            zIndex: 0,
                            width: '40px',
                            height: '40px',
                        }}
                    >
                        <CircularProgress />
                    </Box>
                    <Suspense>
                        {props.open ? (
                            <ReactPlayer
                                style={{ position: 'relative', zIndex: 1 }}
                                url={`https://www.youtube.com/watch?v=${videoId}`}
                                config={{
                                    youtube: {
                                        playerVars: {
                                            rel: 0,
                                            showinfo: 0,
                                        },
                                    },
                                }}
                                playing={true}
                                width="100%"
                                height="100%"
                            />
                        ) : null}
                    </Suspense>
                </Box>
            </AspectRatio>
        </Dialog>
    );
};
